import { render, staticRenderFns } from "./SupportCalculatorTab.vue?vue&type=template&id=6f89ac7b&scoped=true"
import script from "./SupportCalculatorTab.vue?vue&type=script&lang=js"
export * from "./SupportCalculatorTab.vue?vue&type=script&lang=js"
import style0 from "./SupportCalculatorTab.vue?vue&type=style&index=0&id=6f89ac7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f89ac7b",
  null
  
)

export default component.exports